import api from './ApiMiddleware';

const impersonateCustomer = (customerId) => {
  return api.post(`/api/v1/customer/${customerId}/impersonate`);
};

const stopImpersonating = () => {
  return api.post(`/api/v1/customer/stopimpersonate`);
};

const isImpersonating = () => {
  return api.get('/api/v1/user/isimpersonating');
};

const SystemAdminService = {
  impersonateCustomer,
  stopImpersonating,
  isImpersonating,
};

export default SystemAdminService;
